<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
      <img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
      <div class="stepbtn" @click="nextStep(status)">
        {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]" />
    <div class="h-content" :class="{'ljjtips':cgflag || zlflag || dlsflag}">
      <div class="h-piece">
        <div class="outerCon" v-if="dlsflag">
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">合同</div>
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">目标</div>
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '2'}" @click="tabchange(2)">目标对阵</div>
        </div>
        <div class="h-formLine weekplandetail23">
          <el-form label-position="right" :model="formInline" ref="form1" :rules="rules" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item label="合同类型" class="h-elformWrap-2" prop="contractCatecory" v-show="!dlsflag || tabIndex=='1'">
              <brselect category="contract_category" @input="changeCatogory" :v="formInline.contractCatecory" v-model="formInline.contractCatecory" style="width:3.1rem" />
            </el-form-item>
            <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractName" v-if="!dlsflag">
              <el-input v-model="formInline.contractName" placeholder="请输入合同名称"></el-input>
            </el-form-item>
            <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractName" v-if="dlsflag && tabIndex=='1'">
              <el-select v-model="formInline.contractName" placeholder="请选择" @change="changeDlsType">
                <el-option value="康盛合同">康盛合同</el-option>
                <el-option value="鸿鹄合同">鸿鹄合同</el-option>
                <el-option value="海盛杰合同">海盛杰合同</el-option>
                <el-option value="厚宏合同">厚宏合同</el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item label="商务合同号" class="h-elformWrap-2" prop="businessContractCode" v-if="cgflag">-->
<!--              <el-input v-model="formInline.businessContractCode" placeholder="请输入商务合同编号"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="云超市合同号" class="h-elformWrap-2"  prop="contractCode" v-if="cgflag">
              <el-input v-model.number="formInline.contractCode" placeholder="请输入云超市合同号"></el-input>
            </el-form-item>
            <el-form-item label="经销商合同类型" class="h-elformWrap-2" prop="contractAgent" v-if="dlsflag && tabIndex=='1'">
              <brselect category="contract_agent" :v="formInline.contractAgent" @change="changeContractAgent($event)" v-model="formInline.contractAgent" style="width:3.1rem" />
            </el-form-item>

            <el-form-item label="对阵一级经销商" class="h-elformWrap-2" prop="oneLevelAgentName" v-if="(formInline.contractAgent==8 || formInline.contractAgent == 2) && (dlsflag && tabIndex=='1')">
              <el-select v-model="formInline.oneLevelAgentName" :title="formInline.oneLevelAgentName" remote filterable :filter-method="showAgentList" clearable placeholder="请输入" :remote-method="showAgentList" @change="changeAgent($event)">
                <el-option v-for="(item) in oneAgentList" :key="item.customerName" :label="item.customerName +'-'+item.usercode" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="关联项目" class="h-elformWrap-2" prop="pid" v-if="!zlflag && !dlsflag && !hhxmflag && !selectProFlag ">
              <el-select v-model="formInline.pid" placeholder="--请先选择合同类型--" clearable filterable @change="changeProject" :disabled="guanlianxiangmFlag">
                <el-option v-for="(item,index) in allProjectByUser" :key="index" :label="item.projectName" :value="item.id">
                  {{ item.projectName }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerCode" v-if="!dlsflag && !selectProFlag">
              <el-select placeholder="请选择" filterable clearable v-model="formInline.customerCode" @change="fillCusName" id="customer">
                <el-option v-for="customer in customerList" :key="customer.usercode" :label="customer.username+'-'+customer.usercode" :value="customer.usercode"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerCode" v-if="(dlsflag && tabIndex=='1') && !selectProFlag">
              <el-select placeholder="请选择" filterable clearable allow-create v-model="formInline.customerCode" @change="fillCusName1" id="customer">
                <el-option v-for="customer in customerList" :key="customer.usercode" :label="customer.username+'-'+customer.usercode" :value="customer.usercode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerCode" v-if="selectProFlag">
              <el-select placeholder="请选择" filterable clearable :filter-method="selectDept" v-model="formInline.customerCode" @change="changeProject">
                <el-option v-for="customer in customerList" :key="customer.usercode" :label="customer.username" :value="customer.usercode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="(dlsflag && tabIndex=='1')&&isCt1 && (formInline.caigouquyu =='' || formInline.caigouquyu == null)">
              <brselect :multiple="true" category="sales_region_ct" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" :clearable="true" />
            </el-form-item>

            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="(dlsflag && tabIndex=='1')&&isCt1 && formInline.caigouquyu == 'L1'">
              <brselect :multiple="true" category="sales_region_ct_L1" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" :clearable="true" />
            </el-form-item>

            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="(dlsflag && tabIndex=='1')&&isCt1 && formInline.caigouquyu == 'L2'">
              <brselect :multiple="true" category="sales_region_ct_L2" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" :clearable="true" />
            </el-form-item>

            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="(dlsflag && tabIndex=='1')&&!isCt1&&!isXueYe">
              <brselect :multiple="true" category="sales_region" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" :clearable="true" />
            </el-form-item>
            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="(dlsflag && tabIndex=='1')&&!isCt1&&isXueYe">
              <brselect :multiple="true" category="sales_region_nd5" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" :clearable="true" />
            </el-form-item>
            <el-form-item label="销售区域" class="h-elformWrap-2" prop="saleareaCode" v-if="dlsflag && !yiji && tabIndex=='1'">
              <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode" @change="changeArea($event)" v-model="formInline.saleareaCode"></brselect>
            </el-form-item>

            <el-form-item label="销售区域" class="h-elformWrap-2 w-elformWrap" prop="saleareaCode" v-if="dlsflag && yiji && tabIndex=='1'">
              <el-select :clearable="true" v-model="formInline.saleareaCode" :v="formInline.saleareaCode" @change="changeArea($event)">
                <el-option v-for="item in salesRegion" :key="item.index" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" v-if="dlsflag && tabIndex=='1'">
              <el-select :multiple="true" :clearable="true" v-model="formInline.salesCity" :v="formInline.salesCity" @change="getCity">
                <el-option v-for="item in salesCity" :key="item.index" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="产品大类" class="h-elformWrap-2" prop="productType" v-if="zlflag">
							<el-select v-model="formInline.productType"
								   placeholder="--请选择产品大类--" clearable @change="changeBig">
								<el-option v-for="item in optionsProduct1"
										   :key="item.id"
										   :label="item.levelname"
										   :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="产品型号" class="h-elformWrap-2" prop="productCode" v-if="zlflag">
							<el-select v-model="formInline.productCode" placeholder="--请选择产品型号--" filterable @change="fillProductName">
								<el-option
									v-for="item in optionsProduct2"
									:key="item.id"
									:label="item.levelname"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="租赁数量" class="h-elformWrap-2" prop="rentNum" v-if="zlflag">
							<el-input v-model.number="formInline.rentNum" placeholder="请输入租赁数量"></el-input>
						</el-form-item> -->
            <el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype" v-if="zlflag">
              <el-select v-model="formInline.zltype" :v="formInline.zltype" placeholder="请选择" @change="selectZlProduct1()">
                <el-option v-for="(item) in zltypeList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同订单类型" class="h-elformWrap-2" prop="nwSale" v-if="zlflag">
              <el-select v-model="formInline.nwSale" :v="formInline.nwSale" placeholder="请选择" @change="selectnwSale()">
                <el-option label="内销订单" value="1"></el-option>
                <el-option label="外销订单" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="租赁方式" class="h-elformWrap-2" prop="rentType" v-if="jzxFlag">
              <brselect clearable category="zulin_type" :v="formInline.rentType" @change="getRentTime()" v-model="formInline.rentType"></brselect>
            </el-form-item>
            <el-form-item label="租赁天数" class="h-elformWrap-2" prop="rentType" v-if="jzxFlag">
              <el-select v-model="formInline.rentTime" @change="stRentTime()" :v="formInline.rentTime" placeholder="请选择">
                <el-option v-for="(item) in rentTimeList" :key="item.rentTerm" :label="item.rentTerm" :value="item.rentTerm">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="租赁时间" class="h-elformWrap-2" prop="rentTime" v-if="zlflag && !jzxFlag">
              <el-col class="yearIcon">
                <el-input v-model.number="formInline.rentTime" placeholder="请输入租赁时间">
                </el-input>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label="保修时间" class="h-elformWrap-2" prop="guaranteeTime" v-if="zlflag">
						<el-col class="yearIcon">
							<el-input v-model.number="formInline.guaranteeTime" placeholder="请输入保修时间">
							</el-input>
						</el-col>
						</el-form-item> -->
            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode" v-if="!cgflag&&!zlflag&&!dlsflag && !hhxmflag">
              <brselect category="sales_region" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" style="width:3.1rem" />
            </el-form-item>
            <el-form-item label="合同金额(元)" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount" v-show="!dlsflag || tabIndex=='1'" v-if="!cgflag && !jzxFlag  && !hhxmflag">
              <el-input v-model.number="formInline.contractAmount" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item label="合同开始时间" class="h-elformWrap-2" prop="contractStarttime" v-show="!dlsflag && !hhxmflag">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.contractStarttime" :picker-options="pickerOptions1" @change="setZlDate()"></el-date-picker>
            </el-form-item>
            <el-form-item label="合同开始时间" class="h-elformWrap-2" prop="contractStarttime" v-show="dlsflag && tabIndex=='1' && formInline.contractName == '国内市场经销合同'">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.contractStarttime" :picker-options="pickerOptions3" @change="setZlDate()"></el-date-picker>
            </el-form-item>
            <el-form-item label="合同开始时间" class="h-elformWrap-2" prop="contractStarttime" v-show="dlsflag && tabIndex=='1' && formInline.contractName != '国内市场经销合同'">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.contractStarttime" :picker-options="pickerOptions1" @change="setZlDate()"></el-date-picker>
            </el-form-item>
            <el-form-item label="合同结束时间" class="h-elformWrap-2" prop="contractEndtime" v-show="!dlsflag && !hhxmflag || (tabIndex=='1' && dlsflag)">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.contractEndtime" :picker-options="pickerOptions2"></el-date-picker>
            </el-form-item>
            <el-form-item label="付款日期" class="h-elformWrap-2" prop="payDate" v-if="cgflag">
              <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="formInline.payDate"></el-date-picker>
            </el-form-item>
            <el-form-item label="用户个数(传统)" class="h-elformWrap-2" prop="userNum" v-if="(dlsflag && tabIndex=='1') && (isCt1 || isXueYe)">
              <el-input v-model.number="formInline.userNum" placeholder="请输入数字" @change="changeUserNum()"></el-input>
            </el-form-item>
            <el-form-item label="链群" class="h-elformWrap-1" prop="lianqun" v-if="dlsflag && tabIndex=='1'">
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isCt1">
                <el-checkbox label="X02">样本网</el-checkbox>
                <el-checkbox label="X01">药品网</el-checkbox>
                <el-checkbox label="X08">生物安全类</el-checkbox>
                <el-checkbox label="X09">培养箱类</el-checkbox>
                <el-checkbox label="X10">离心机</el-checkbox>
                <el-checkbox label="X06">疫苗网</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isNA9">
                <el-checkbox label="X12">航空温控</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isKs1">
                <el-checkbox label="X13">康盛</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isSj1">
                <el-checkbox label="X04">海盛杰</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isHh1">
                <el-checkbox label="X14">厚宏</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" v-if="isXueYe">
                <el-checkbox label="X05">血液网</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!--<el-form-item label="收益分摊周期" class="h-elformWrap-2" prop="zsyzq" v-if="zlflag">-->
            <!--<el-select v-model="formInline.zsyzq" :v="formInline.zsyzq" placeholder="请选择">-->
            <!--<el-option v-for="(item) in zsyzqList"-->
            <!--:key="item.code"-->
            <!--:label="item.name"-->
            <!--:value="item.code">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item label="是否附加损坏豁免" class="h-elformWrap-2" prop="zltype" v-if="jzxFlag">
              <el-select v-model="formInline.isShhm" :v="formInline.isShhm" placeholder="请选择" @change="adds_hm">
                <el-option v-for="(item) in jjhmList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提箱点" class="h-elformWrap-2" prop="rentPlace" v-if="jzxFlag">
              <el-input v-model="formInline.rentPlace" placeholder="请输入提箱点"></el-input>
            </el-form-item>
            <el-form-item label="还箱点" class="h-elformWrap-2" prop="returnPlace" v-if="jzxFlag">
              <el-input v-model="formInline.returnPlace" placeholder="请输入还箱点"></el-input>
            </el-form-item>
            <el-form-item label="是否加急" class="h-elformWrap-2" prop="zltype" v-if="jzxFlag">
              <el-select v-model="formInline.isJj" :v="formInline.isJj" placeholder="请选择" @change="adds_jj">
                <el-option v-for="(item) in jjList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货币种类" class="h-elformWrap-2" prop="currencyCode" v-if="'CT-ZL' == formInline.contractCatecory && '3' == formInline.zltype">
              <brselectlazy category="YLCurrency" :v="formInline.currencyCode" v-model="formInline.currencyCode" :clearable="false" :disabled="true" />
            </el-form-item>
          </el-form>
          <el-form label-position="right" :model="formInline" ref="form4" :rules="rules2" :inline="true" class="demo-ruleForm h-formbLine" v-if="hhxmflag">
            <el-form-item label="区域" class="h-elformWrap-2" prop="saleareaCode" v-if="hhxmflag" :rules="rules2.saleareaCode">
              <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode" @change="changeArea($event)" v-model="formInline.saleareaCode"></brselect>
            </el-form-item>

            <el-form-item label="地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" v-if="hhxmflag" :rules="rules2.salesCity">
              <el-select :multiple="true" :clearable="true" v-model="formInline.salesCity" :v="formInline.salesCity" @change="getCity">
                <el-option v-for="item in salesCity" :key="item.index" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="质保期(月)" class="h-elformWrap-2" prop="guaranteeTime" v-show="hhxmflag" :rules="rules2.guaranteeTime">
              <el-input v-model.number="formInline.guaranteeTime" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item label="合同金额(元)" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount" :rules="rules2.contractAmount" v-show="hhxmflag">
              <el-input v-model.number="formInline.contractAmount" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item label="回款模式" class="h-elformWrap-2" prop="rentPlace" :rules="rules2.rentPlace" v-show="hhxmflag">
              <el-input v-model="formInline.rentPlace" type="text"></el-input>
            </el-form-item>

          </el-form>
          <el-form label-position="right" :model="formInline1" ref="form2" :rules="rules" :inline="true" class="demo-ruleForm h-formbLine" v-if="!zlflag && !bzflag && !dlsflag && !hhxmflag">
            <el-form-item label="付款条件" class="h-elformWrap-1" prop="condition" v-if="!cgflag && !dlsflag && !hhxmflag">
              <div class="h-checkBox">
                <el-checkbox-group v-model="formInline1.condition">
                  <el-checkbox label="现金"></el-checkbox>
                  <el-checkbox label="信贷"></el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <!--						<el-form-item label="物流方式" class="h-elformWrap-1" prop="wuliufangshi"  v-if="cgflag">
							<div class="h-checkBox">
								<el-radio-group v-model="formInline1.wuliufangshi">
									<el-radio :label="1">海尔自有物流</el-radio>
									<el-radio :label="2">供应商直发</el-radio>
									<el-radio :label="3">两者皆可</el-radio>
								 </el-radio-group>
							</div>
						</el-form-item>-->
          </el-form>
        </div>
        <div v-if="cgflag">
          <div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
            <h1>产品信息</h1>
          </div>
          <el-form ref="form5" :model="formInline" v-if="!selectProFlag">
            <el-table ref="multipleTable" :data="formInline.productList" stripe border style="width: 100%">
              <el-table-column type="index" label="#" width="40">
              </el-table-column>
              <el-table-column prop="productId" label="产品型号" width="160">
              </el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="产品名称" width="180">
              </el-table-column>
              <el-table-column prop="oemDesc" :show-overflow-tooltip="true" label="规格型号" width="180">
              </el-table-column>
              <el-table-column prop="unitPrice" label="产品价格" width="140">
              </el-table-column>
              <el-table-column prop="currency" min-width="100" :show-overflow-tooltip="true" label="币种">
                <template slot-scope="scope">
                  {{scope.row.currency | dictname('YLCurrency')}}
                </template>
              </el-table-column>
              <el-table-column prop="shuilv" label="发票税率" width="140">
                <template scope="scope">
                  <brselect category="cgshuilv" :v="scope.row.shuilv" v-model="scope.row.shuilv" />
                </template>
              </el-table-column>
              <el-table-column prop="cgjingli" label="采购经理">
                <template scope="scope">
                  <brselect :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli" />
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <el-form ref="form5" :model="formInline" v-if="selectProFlag">
            <el-table ref="multipleTable" :data="formInline.productList" style="width: 100%">
              <el-table-column prop="productId" label="产品型号" width="140">
                <template slot-scope="scope">
                  <el-input class="h-tableInput" v-model.trim="scope.row.productId" style="height: 0.35rem;" placeholder="请输入" @change="selectDetailModel(scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="产品名称" width="140">
              </el-table-column>
              <el-table-column prop="oemDesc" :show-overflow-tooltip="true" label="规格型号" width="140">
              </el-table-column>
              <el-table-column prop="unitPrice" label="产品价格" min-width="110">

                <template slot-scope="scope">
                  <el-input v-model="scope.row.unitPrice" placeholder="请输入" @keyup.native='keyupEvent($event,input)' class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="currency" min-width="120" :show-overflow-tooltip="true" label="币种">
                <template slot-scope="scope">
                  <brselect category="YLCurrency" :v="scope.row.currency" v-model="scope.row.currency" />
                </template>
              </el-table-column>
              <el-table-column prop="shuilv" label="发票税率" width="140">
                <template scope="scope">
                  <brselect category="cgshuilv" :v="scope.row.shuilv" v-model="scope.row.shuilv" />
                </template>
              </el-table-column>
              <el-table-column prop="cgjingli" label="采购经理">
                <template scope="scope">
                  <brselect :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delzhongbiao(scope.$index,scope.row)">删除
                  </el-button>

                </template>
              </el-table-column>
            </el-table>
            <div v-if="selectProFlag" class="h-tableAdd" @click="showProcuct1">
              <a>新增一行</a>
            </div>
          </el-form>
        </div>
        <div v-if="zlflag">
          <div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
            <h1>租赁型号</h1>
          </div>
          <el-form ref="form5" :model="formInline" :rules="rules1">
            <el-table ref="multipleTable" :data="formInline.zlList" style="width: 100%">
              <el-table-column type="index" width="40" label="#">
              </el-table-column>
              <el-table-column prop="productType" v-if="!jzxFlag" :key="Math.random()" label="产品大类">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.productType'" :rules="rules1.productType" style="margin-bottom: 0;">
                    <el-select v-model="scope.row.productType" style="width: 100%;" placeholder="--请选择产品大类--" clearable @change="changeBig(scope.row)">
                      <el-option v-for="item in optionsProduct1" :key="item.id" :label="item.levelname" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="productCode" label="产品型号">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.productCode'" :rules="rules1.productCode" style="margin-bottom: 0;">
                    <el-select style="width: 100%;" v-model="scope.row.productCode" placeholder="请选择" filterable remote @change="fillProductName(scope.row)" :remote-method="remoteMethod">
                      <el-option v-for="item in jzxFlag ? optionsProduct2_jzx.slice(0,10) : scope.row.optionsProduct2" :key="jzxFlag ? Math.random() : item.id" :label="jzxFlag ? item.id : item.levelname" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="productName" v-if="jzxFlag" label="产品名称">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.productName'" :rules="rules1.productName" style="margin-bottom: 0;">
                    <el-input :disabled="true" v-model.number="scope.row.productName" placeholder="请输入"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="priceType" :key="Math.random()" v-if="jzxFlag" label="费用名称">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.priceType'" :rules="rules1.priceType" style="margin-bottom: 0;">

                    <desselect clearable category="price_type" :des="1" :v="scope.row.priceType" @change="getRentPrice(scope.row.priceType,scope.$index)" v-model="scope.row.priceType"></desselect>

                    <!--                 <el-select style="width: 100%;" v-model="scope.row.priceType" placeholder="请选择" filterable @change="fillProductName(scope.row)">-->
                    <!--                   <el-option-->
                    <!--                       v-for="item in scope.row.optionsProduct2"-->
                    <!--                       :key="item.id"-->
                    <!--                       :label="item.levelname"-->
                    <!--                       :value="item.id">-->
                    <!--                   </el-option>-->
                    <!--                 </el-select>-->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="productUnitPrice" :label="!jzxFlag?'产品单价':'单价'">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.productUnitPrice'" :rules="rules1.productUnitPrice" style="margin-bottom: 0;">
                    <el-input v-model="scope.row.productUnitPrice" placeholder="请输入" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="rentNum" :label="!jzxFlag?'租赁数量':'数量'">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.rentNum'" :rules="rules1.rentNum" style="margin-bottom: 0;">
                    <el-input v-model.number="scope.row.rentNum" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="productTotalPrice" v-if="jzxFlag" label="金额">
                <template scope="scope">
                  <el-form-item :prop="'zlList.'+scope.$index+'.productTotalPrice'" :rules="rules1.productTotalPrice" style="margin-bottom: 0;">
                    <el-input v-model="scope.row.productTotalPrice =(scope.row.productUnitPrice * scope.row.rentNum).toFixed(2)" placeholder="0.00"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="delIndex1(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <div class="h-tableAdd" @click="adds1">
            <a>新增一行</a>
          </div>
        </div>
        <div v-if="cgflag || (zlflag && formInline.zltype == '1')">
          <div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
            <h1>付款节点</h1>
          </div>
          <el-form ref="form3" :model="formInline" :rules="rules">
            <el-table ref="multipleTable" :data="formInline.paymentList" style="width: 100%">
              <el-table-column type="index" width="40" label="#">
              </el-table-column>
              <el-table-column label="节点名称">
                <template scope="scope">
                  <el-form-item :prop="'paymentList.'+scope.$index+'.nodeName'" :rules="rules.nodeName" ref="bili2" style="margin-bottom: 0;">
                    <!--				                <el-input v-model="scope.row.nodeName" :readonly="!scope.row.newflag"></el-input>-->
                    <!--				                <el-input v-model="scope.row.nodeName"></el-input>-->
                    <brselect category="payment_node" :v="scope.row.nodeName" v-model="scope.row.nodeName" clearable />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="paymentRatio" label="付款比例(%)" width="150">
                <template scope="scope">
                  <el-form-item :prop="'paymentList.'+scope.$index+'.paymentRatio'" :rules="rules.paymentRatio" style="margin-bottom: 0;">
                    <el-input @blur="linkMoney(scope.$index,'ratio')" v-model="scope.row.paymentRatio"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="paymentAmount" label="开票金额(元)" width="150" v-if="zlflag">
                <template scope="scope">
                  <el-form-item :prop="'paymentList.'+scope.$index+'.paymentAmount'" :rules="rules.paymentAmount" style="margin-bottom: 0;">
                    <el-input @blur="linkMoney(scope.$index,'amount')" v-model="scope.row.paymentAmount"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="netValue" label="净价值(元)" width="150" v-if="zlflag">
                <template scope="scope">
                  <el-form-item :prop="'paymentList.'+scope.$index+'.netValue'" :rules="rules.netValue" style="margin-bottom: 0;">
                    <el-input @blur="linkMoney(scope.$index,'net')" v-model="scope.row.netValue"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--<el-table-column
				        prop="paymentDays"
				        label="账期(天)"
				        width="150">
				            <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.paymentDays'" :rules="rules.paymentDays"  style="margin-bottom: 0;">
									<el-input v-model.number="scope.row.paymentDays" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
								</el-form-item>
				            </template>
				        </el-table-column>
-->
              <el-table-column prop="posnr" label="项目号" v-if="false" width="150">
              </el-table-column>

              <el-table-column prop="billDate" label="计划开票时间" width="250" v-if="zlflag">
                <template scope="scope">
                  <el-form-item :prop="'paymentList.'+scope.$index+'.billDate'" :rules="rules.billDate" style="margin-bottom: 0;">
                    <el-date-picker :clearable="false" type="date" placeholder="选择时间" v-model="scope.row.billDate"></el-date-picker>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--				        <el-table-column
				        prop="isNeedcred"
				        label="是否需要凭证"
				        width="200" v-if="cgflag">
				            <template scope="scope">
								<el-form-item :prop="'paymentList.'+scope.$index+'.isNeedcred'" :rules="rules.isNeedcred"  style="margin-bottom: 0;">
									<el-radio-group v-model="scope.row.isNeedcred">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
				            </template>
				        </el-table-column>-->
              <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.newflag" @click="delIndex(scope.$index)">删除</el-button>
                  <el-button type="text" v-if="scope.row.newflag" @click="copyIndex(scope.row)">复制</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <div class="h-tableAdd" @click="adds">
            <a>新增一行</a>
          </div>

        </div>
        <div v-if="zlflag && formInline.zltype == '1'" style="margin-top: 0.3rem;">
          <el-form ref="form6" :model="formInline" :rules="rules">
            <el-table ref="multipleTable" :data="formInline.fukuanobj" style="width: 100%">
              <el-table-column type="index" width="40" label="#">
              </el-table-column>
              <el-table-column prop="nodeName" label="节点名称">
                <template scope="scope">
                  <el-form-item :prop="'fukuanobj.'+scope.$index+'.nodeName'" :rules="rules.nodeName" style="margin-bottom: 0;">
                    <el-input v-model="scope.row.nodeName" :readonly="!scope.row.newflag"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="paymentRatio" label="付款比例(%)" width="150">
                <template scope="scope">
                  <el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentRatio'" :rules="rules.paymentRatio" style="margin-bottom: 0;">
                    <el-input @blur="linkMoney(scope.$index,'yj')" v-model="scope.row.paymentRatio"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="paymentAmount" label="付款金额(元)" width="150">
                <template scope="scope">
                  <el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentAmount'" :rules="rules.paymentAmount" style="margin-bottom: 0;">
                    <el-input v-model="scope.row.paymentAmount"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="netValue" label="净价值(元)" width="150">
                <template scope="scope">
                  <el-form-item :prop="'fukuanobj.'+scope.$index+'.netValue'" :rules="rules.netValue" style="margin-bottom: 0;">
                    <el-input v-model="scope.row.netValue"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="paymentDays" label="账期(天)" width="150">
                <template scope="scope">
                  <el-form-item :prop="'fukuanobj.'+scope.$index+'.paymentDays'" :rules="rules.paymentDays" style="margin-bottom: 0;">
                    <el-input v-model.number="scope.row.paymentDays" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>

        </div>
        <div class="h-pieceInCon3 h-mrt0 h-mrl100" style="margin-bottom:50px;" v-if="!cgflag && !zlflag && !bzflag && !dlsflag && !hhxmflag">
          <div class="h-formLine h-mrb-38">
            <el-form :model="formInline" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item label="现金" class="h-elformWrap-2">
                <el-col :span="10" class="h-percentageIcon">
                  <el-input v-model="formInline.cashRatio" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                </el-col>
                <el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
                <el-col :span="10" class="h-moneyIcon2">
                  <el-input v-model="formInline.cashAmount" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="信贷" class="h-elformWrap-2">
                <el-col :span="10" class="h-percentageIcon">
                  <el-input v-model="formInline.creditRatio" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                </el-col>
                <el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
                <el-col :span="10" class="h-moneyIcon2">
                  <el-input v-model="formInline.creditAmount" placeholder="请输入数字" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="h-formLine h-mrt40 weekplandetail1">
          <el-form label-position="right" :model="file" :rules="rules" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item label="合同附件" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2" v-show="!dlsflag || tabIndex=='1'" required style="width: 100%;" prop="name">
              <brupload :refid="this.contractId" reftype="合同附件" uploadflag delflag></brupload>
            </el-form-item>

            <el-form-item label="工程专业承包资质" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2" v-show="(!dlsflag || tabIndex=='1') && isKa" required style="width: 100%;" prop="name">
              <brupload :refid="this.contractId" reftype="合同工程专业承包资质" uploadflag delflag></brupload>
            </el-form-item>

          </el-form>
        </div>
        <!--<div class="h-formLine h-mrt40 weekplandetail1">
					<el-form label-position="right" :model="file" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="对阵合同" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2" v-show="dlsflag && tabIndex=='1' && formInline.contractAgent == 2" required style="width: 100%;" prop="name">
							<brupload :refid="this.contractId" reftype="合同附件-对阵合同" uploadflag delflag></brupload>
						</el-form-item>
					</el-form>
				</div>-->

        <el-table ref="multipleTable" v-show="tabIndex == '2'" :data="tableData2" :border="true" stripe max-height="560" style="width: 100%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
          <el-table-column prop="year" label="年份" width="60px"></el-table-column>
          <el-table-column prop="province" label="省份" width="90px"></el-table-column>
          <el-table-column prop="city" label="地市" width="90px"></el-table-column>
          <el-table-column prop="scenesName" label="渠道" width="90px"></el-table-column>
          <el-table-column prop="agentName" label="经销商" width="150px" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column prop="contractId" label="经销商合同" width="120px"></el-table-column> -->
          <el-table-column prop="customerName" label="用户名称" width="180px">
            <template slot-scope="scope">
              <div v-if="scope.row.cloor == true" style="color: #F56C6C;">
                {{scope.row.customerName}}
              </div>
              <div v-if="scope.row.cloor == false">
                {{scope.row.customerName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="incomeTarget" label="预计目标收入(万元)" width="100px"></el-table-column>
          <el-table-column prop="distributorUsers" label="分销商3.0" width="150px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="facingyewuyuan" label="对阵业务员" width="100px"></el-table-column>
          <el-table-column prop="isTop" label="是否TOP" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.isTop == 0">否</span> <span v-if="scope.row.isTop == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="memo" label="子场景" width="110px" :show-overflow-tooltip="true"></el-table-column>

          <el-table-column prop="status" label="状态" width="120px">
            <template slot-scope="scope">
              <div v-if="scope.row.delflag == 1">
                <span v-if="scope.row.status == '' || scope.row.status == null">正常</span>
                <span v-if="scope.row.status == 1">正常</span>
                <span v-if="scope.row.status == 2">已提交删除</span>
                <span v-if="scope.row.status == 3">修改审批中</span>
                <span v-if="scope.row.status == 4">新增审批中</span>
                <span v-if="scope.row.status == 5">驳回审批</span>
                <span v-if="scope.row.status == 0">已删除</span>
              </div>
              <div v-if="scope.row.delflag == 0">
                <span v-if="scope.row.delflag == 0">已删除</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="agentLevel" label="经销商类型" width="110px">
            <template slot-scope="scope">
              <span v-if="scope.row.agentLevel == 1">一级经销商</span>
              <!-- <span v-if="scope.row.agentLevel == 2">分销商</span> -->
              <span v-if="scope.row.agentLevel == 3">专营商</span>
              <!-- <span v-if="scope.row.agentLevel == 4">直单用户</span>
                            <span v-if="scope.row.agentLevel == 5">分销商3.0</span> -->
              <span v-if="scope.row.agentLevel == 6">地市直营商</span>
            </template>
          </el-table-column>
          <el-table-column prop="againstMode" label="对阵模式" width="150px">
            <template slot-scope="scope">
              {{scope.row.againstMode|dictname('against_mode')}}
            </template>
          </el-table-column>
          <el-table-column prop="facingReseller" label="对阵分销商1.0" width="100px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="cuname" label="创建人" width="100px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="cdate" label="创建时间" width="140px"></el-table-column>
        </el-table>

      </div>
      <div class="h-txtCenter h-mrt60">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="save" v-if="!dlsflag && !hhxmflag">暂存</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit" v-if="!dlsflag && !hhxmflag">确认提交</el-button>

        <el-button class="h-btn h-bBtn h-bggreen" @click="submitAgent('1')" v-if="dlsflag">暂存</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitAgent('0')" v-if="dlsflag">确认提交</el-button>

        <el-button class="h-btn h-bBtn h-bggreen" @click="submitHHxm('1')" v-if="hhxmflag">暂存</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitHHxm('0')" v-if="hhxmflag">确认提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import big from 'big.js';
import ss from "../../../api/SystemService";
import util from "../../../utils/util";
export default {
  name: 'leftMenu',
  data () {
    return {
      // 新手引导页
      toshow: "contract-new2",
      checked: true,
      tabIndex: null,
      status: 1,
      showOrhide: false,
      guanlianxiangmFlag: true,

      optionsProduct2_jzx: [],
      optionsProduct2: [],
      optionsProduct1: [],
      tableData2: [],
      tableData3: [],
      lianqunList: [],
      customerlabel: "客户名称",
      allProjectByUser: [],
      tempProject: [],
      tempProject2: [],
      salesCity: [],//销售地区
      salesRegion: [],//销售省区
      cgflag: false,
      zlflag: false,
      bzflag: false,
      dlsflag: false,
      yiji: false,
      isKa:false,
      hhxmflag: false,
      shichang: true,
      pickerOptions1: {
        disabledDate: (time) => {
          if (this.formInline.contractEndtime != "") {
            return time.getTime() > this.formInline.contractEndtime;
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.formInline.contractCatecory == "CT-DLS-KJ" || this.formInline.contractCatecory == "经销商框架合同") {
            return time.getTime() < Date.now() - 8.64e7;
          } else if (this.formInline.contractStarttime != "") {
            return time.getTime() < this.formInline.contractStarttime;
          }
        }
      },
      pickerOptions3: {
        disabledDate: (time) => {
          if (this.formInline.contractEndtime != "") {
            return time.getTime() > this.formInline.contractEndtime;
          } else {
            return time.getTime() < Date.now() - 86400000;
          }
        }
      },
      //表单
      formInline: {
        zltype: "",
        contractName: "",
        pid: "",
        customerCode: "",
        currencyCode: null,//币种
        salechannelCode: "",
        contractCatecory: "",
        contractAmount: "",
        contractStatus: "",
        contractStarttime: "",
        userNum: "",
        contractEndtime: "",
        contractCashPledge: "",
        contractCode: "",
        paymentList: [{
          nodeName: "", newflag: false, paymentRatio: "", posnr: "",
          paymentAmount: "", netValue: "", paymentDays: "", isNeedcred: "", billPayMonty: "", billDate: ""
        }],
        zlList: [
          {
            productType: '',
            productCode: '',
            rentNum: '',
            productName: '',
            productUnitPrice: '',
            pickerOptions2: []
          }
        ],
        fukuanobj: [
          {
            nodeName: "押金",
            newflag: false,
            paymentRatio: "",
            paymentAmount: "",
            posnr: "",
            netValue: "",
            paymentDays: "",
            billPayMonty: ""
          }
        ],
        productCode: "",
        productName: "",
        productPrice: "",
        productType: "",
        rentNum: "",
        rentTime: "",
        guaranteeTime: "",
        productList: [],
        zsyzq: "",
        payDate: "",
        businessContractCode: "",
        rentType: "",
        isShhm: 0,
        isJj: 0,
        rentPlace: "",
        returnPlace: "",
        rentPrice: "",
        contractAgent: "",
        saleareaCode: "",
        status: "",
        isZc: "",
        lianqun: "",
        salesCity: "",
        nwSale: null,
        caigouquyu:"",
      },
      formInline1: {
        wuliufangshi: 2,
        condition: []
      },
      contractId: this.$route.query.contractId,
      customerList: [],
      //多选
      checkList: [],
      fileList: [],
      oneAgentList: [],
      isCt: false,
      isCt1: false,
      isNA9: false,
      isKs1: false,
      isSj1: false,
      isHh1: false,
      isXueYe: false,
      file: {
        name: ''
      },
      zltypeList: [
        { code: 1, name: "房屋" },
        { code: 2, name: "疫苗车" },
        { code: 3, name: "集装箱" }
      ],
      jjhmList: [
        { code: 1, name: "是" },
        { code: 0, name: "否" }
      ],
      jjList: [
        { code: 1, name: "是" },
        { code: 0, name: "否" }
      ],
      zsyzqList: [{ code: 1, name: "1" },
      { code: 2, name: "2" }, { code: 3, name: "3" }, { code: 4, name: "4月" }, { code: 5, name: "5" },
      { code: 6, name: "6" }, { code: 7, name: "7" }, { code: 8, name: "8月" }, { code: 9, name: "9" },
      { code: 10, name: "10" }, { code: 11, name: "11" }, { code: 12, name: "12" },
      ],
      rules1: {
        productType: [
          { required: true, message: '请选择产品大类', trigger: 'change' },
        ],
        productCode: [
          { required: true, message: '请选择产品型号', trigger: 'change' },
        ],
        rentNum: [
          { required: true, message: '请输入租赁数量', trigger: 'blur' },
        ],
        productUnitPrice: [
          { required: true, message: '请输入型号单价', trigger: 'blur' },

        ],
      },

      rules2: {
        contractAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        guaranteeTime: [
          { required: true, message: '请输入质保期', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        rentPlace: [
          { required: true, message: '请输入回款模式', trigger: 'blur' },
        ],
        saleareaCode: [
          { required: true, message: '请选择销售省区', trigger: 'change' },
        ],
        salesCity: [
          { required: true, message: '请选择销售地市', trigger: 'change' },
        ],
      },

      rules: {
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'blur' },
        ],
        pid: [
          { required: true, message: '请输入关联项目编码', trigger: 'blur' },
        ],
        customerCode: [
          { required: true, message: '请先选择合同类型', trigger: 'change' },
        ],
        salechannelCode: [
          { required: true, message: '请选择销售渠道', trigger: 'change' },
        ],
        saleareaCode: [
          { required: true, message: '请选择销售省区', trigger: 'change' },
        ],
        salesCity: [
          { required: true, message: '请选择销售地市', trigger: 'change' },
        ],
        contractAmount: [
          { required: true, message: '请输入合同金额', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        contractCashPledge: [
          { required: true, message: '请输入押金金额', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        contractCatecory: [
          { required: true, message: '请选择合同类型', trigger: 'change' },
        ],
        contractAgent: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        oneLevelAgentName: [
          { required: true, message: '请输入经销商', trigger: 'change' },
        ],
        contractStarttime: [
          { required: true, message: '请输入合同开始时间', trigger: 'blur' },
        ],
        contractEndtime: [
          { required: true, message: '请输入合同结束时间', trigger: 'blur' },
        ],
        condition: [
          { required: true, message: '请输入付款条件', trigger: 'change' },
        ],
        productCode: [
          { required: true, message: '请先选择关联项目', trigger: 'blur' },
        ],
        productName: [
          { required: true, message: '请先选择关联项目', trigger: 'blur' },
        ],
        shuilv: [
          { required: true, message: '请输入发票税率', trigger: 'change' },
          { type: 'number', message: "必须为数字值" }
        ],
        /*					wuliufangshi:[
                    { required: true, message: '请选择物流方式', trigger: 'change' },
                  ],*/
        nodeName: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
        ],
        paymentRatio: [
          { required: true, message: '请输入付款比例', trigger: 'blur' },
        ],
        paymentAmount: [
          { required: true, message: '请输入付款金额', trigger: 'blur' },
        ],
        netValue: [
          { required: true, message: '请输入净价值', trigger: 'blur' },
        ],
        /*					paymentDays:[
                    { required: true, message: '请输入账期', trigger: 'blur' },
                  ],
                  isNeedcred:[
                    { required: true, message: '请选择是否需要凭证', trigger: 'change' },
                  ],*/
        productPrice: [
          { required: true, message: '请先选择关联项目', trigger: 'blur' },
        ],
        rentTime: [
          { required: true, message: '请输入租赁时间', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        guaranteeTime: [
          { required: true, message: '请输入保修时间', trigger: 'blur' },
          { type: 'number', message: "必须为数字值" }
        ],
        billDate: [
          { required: true, message: '请输入计划开票时间', trigger: 'blur' },
        ],
        // zsyzq:[
        // 	{ required: true, message: '请选择收益分摊周期', trigger: 'change' },
        // ],
        zltype: [
          { required: true, message: '请选择租赁类型', trigger: 'change' },
        ],
        rentType: [
          { required: true, message: '请选择租赁方式', trigger: 'change' },
        ],
        rentTime: [
          { required: true, message: '请选择租赁天数', trigger: 'change' },
        ],
        rentPlace: [
          { required: true, message: '请输入提箱点', trigger: 'change' },
        ],
        returnPlace: [
          { required: true, message: '请输入还箱点', trigger: 'change' },
        ],
        isShhm: [
          { required: true, message: '请选择是否损坏豁免', trigger: 'change' },
        ],
        isJj: [
          { required: true, message: '请选择是否加急', trigger: 'change' },
        ],
        userNum: [
          { required: true, message: '请填写用户个数', trigger: 'change' },
        ],
        nwSale: [
          { required: true, message: '请选择合同使用订单类型', trigger: 'change' },
        ],
      },
      jzxFlag: false,
      selectProFlag: false,
      rentTimeList: [],
      businessContractCode: [
        { required: true, message: '请输入商务合同编号', trigger: 'blur' }
      ],
      payDate: [
        { required: true, message: '请输入付款日期', trigger: 'blur' },
      ],
    }
  },
  methods: {
    linkMoney (index, data) {

      if (data == "ratio") {
        this.formInline.paymentList[index].paymentAmount = new big(this.formInline.contractAmount).times(this.formInline.paymentList[index].paymentRatio).div(100).toFixed(2).toString();
        this.formInline.paymentList[index].netValue = new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();



      } else if (data == "amount") {
        this.formInline.paymentList[index].paymentRatio = new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();
        this.formInline.paymentList[index].netValue = new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();


      } else if (data == "net") {
        this.formInline.paymentList[index].paymentAmount = new big(this.formInline.paymentList[index].netValue).times(1.13).toFixed(2).toString();
        this.formInline.paymentList[index].paymentRatio = new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();


      } else if (data == "yj") {
        this.formInline.fukuanobj[index].paymentAmount = new big(this.formInline.contractAmount).times(this.formInline.fukuanobj[index].paymentRatio).div(100).toFixed(2).toString();
        this.formInline.fukuanobj[index].netValue = new big(this.formInline.fukuanobj[index].paymentAmount).div(1.13).toFixed(2).toString();
      }
      this.formInline.paymentList[index].posnr = (index + 1);

    },
    /*htje(data) {
     this.formInline.paymentList = [{nodeName:"",paymentRatio:"",paymentAmount:"",netValue:"",
          paymentDays:"",isNeedcred:"",newflag:true,billPayMonty:"",billDate:""}];
    },*/
    delIndex (index) {
      this.formInline.paymentList.splice(index, 1)
    },
    delIndex1 (index) {
      this.formInline.zlList.splice(index, 1)
    },
    copyIndex (data) {
      this.formInline.paymentList.push({
        nodeName: data.nodeName, paymentRatio: data.paymentRatio, paymentDays: data.paymentDays,
        newflag: true, billDate: data.billDate, billPayMonty: data.billPayMonty
      });
    },
    adds () {
      var a = {
        nodeName: "", paymentRatio: "", paymentAmount: "", netValue: "", posnr: "",
        paymentDays: "", isNeedcred: "", newflag: true, billPayMonty: "", billDate: ""
      };
      this.formInline.paymentList.push(a)
    },
    adds1 () {
      var a = { productType: "", productCode: "", rentNum: 1, productUnitPrice: "" };
      this.formInline.zlList.push(a)
    },
    // 集装箱  豁免、加急
    adds_hm (q) {
      var data = {
        priceType: null,
        isShhm: 1,
        isJj: 0,
      }
      data.priceType = "ZL08";
      ss.contractService.selectByRentType(data).then(rd => {
        if (rd.f) {
          var list = rd.msg;
          if (q == 1 && this.formInline.zlList[0].priceType == null) {
            // this.$store.getters.dicts.price_type.find(t=>t.code=="")
            this.formInline.zlList[0].priceType = "ZL08";
            this.formInline.zlList[0].productUnitPrice = list[0].untiPrice;
          } else if (q == 1) {
            this.formInline.zlList.push({ priceType: "ZL08", productUnitPrice: list[0].untiPrice, rentNum: 0 });
          }
        }
      })
    },
    adds_jj (q) {
      var data = {
        priceType: null,
        isShhm: 0,
        isJj: 1,
        unitPrice: 0,
      }
      data.priceType = "ZL05";
      ss.contractService.selectByRentType(data).then(rd => {
        if (rd.f) {
          var list = rd.msg;
          if (q == 1 && this.formInline.zlList[0].priceType == null) {
            this.formInline.zlList[0].priceType = "ZL05";
            this.formInline.zlList[0].productUnitPrice = list[0].untiPrice;
          } else if (q == 1) {
            this.formInline.zlList.push({ priceType: "ZL05", productUnitPrice: list[0].untiPrice, rentNum: 0 });
          }
        }
      })

    },
    selectDept (val) {
      ss.ProService.getAllSupplier(val).then(rd => {
        console.log(rd, "optionsSupplier");
        if (rd.f) {
          this.customerList = [];
          for (var i = 0; i < rd.msg.length; i++) {
            var data = rd.msg[i];
            this.customerList.push({ "usercode": data.usercode, "username": data.userName });
          }
        }
      })
    },
    changeProject (attr) {
      if (this.formInline.contractCatecory == "CT-CG") {
        this.customerList = [];
        if (!this.selectProFlag) {
          ss.contractService.getFinalSuppliers({ projectId: attr }).then(rd => {
            if (rd != null && rd.length > 0) {
              _.forEach(rd, (value) => {
                this.customerList.push({ "usercode": value.final_supplier, "username": value.final_supplier_name });
              })
            }
          })
        } else {
          this.formInline.productList.forEach((item, index) => {
            if (item.customerCode == this.formInline.customerCode) {
              this.formInline.customerCode = item.username;
            }
          })
        }
      }
    },
    fillCusName (data) {
      let obj = {};
      obj = this.customerList.find((item) => {
        return item.usercode === data;
      });
      this.formInline.customerName = obj.username;
      if (this.formInline.contractCatecory == "CT-CG") {
        ss.contractService.getProductInfoBySupplier({ "projectId": this.formInline.pid, "finalSupplier": data }).then(rd => {
          this.formInline.productList = rd;
        })
      }
      this.changeGetCurrency()
    },
    /**
     *校验合同类型选择租赁合同 && 租赁类型选择集装箱 && 客户编码不为空，获取币种信息
     */
    changeGetCurrency () {
      if ('CT-ZL' == this.formInline.contractCatecory && this.formInline.zltype == '3' &&
        '' != this.formInline.customerCode && null != this.formInline.customerCode) {
        ss.contractService.getOneViewAgentListByUsercode(this.formInline.customerCode).then(res => {
          console.log(res)
          if (null != res) {
            this.formInline.currencyCode = res.currencycodeSell
          }
        })
      } else {
        this.formInline.currencyCode = '';
      }
    },
    fillCusName1 (data) {
      let obj = {};
      obj = this.customerList.find((item) => {
        return item.usercode === data;
      });
      console.log(obj, "obj")
      if (obj != undefined) {
        this.formInline.customerCode = obj.usercode;
        this.formInline.customerName = obj.username;
      } else {
        this.formInline.customerName = this.formInline.customerCode
      }
    },
    // 产品型号搜索
    remoteMethod (query) {
      let that = this;
      if (query !== '') {
        ss.contractService.selectByCode({ prodcode: query }).then(rd => {
          if (rd.f) {
            that.optionsProduct2_jzx = rd.msg.map((item, index) => {
              return Object.assign({}, { 'id': item.prodcode, 'levelname': item.promodel })
            });
            // console.log(121,rd);
          }
        })
      }
    },
    fillProductName (data, p) {
      let that = this;
      // 集装箱
      if (that.jzxFlag) {
        // data.productName
        data.productName = that.optionsProduct2_jzx.find(t => t.id == data.productCode).levelname;
      } else {
        data.optionsProduct2.forEach(res => {
          if (res.id == data.productCode) {
            data.productName = res.levelname;
          }
        })
      }
    },
    cancel () {
      this.$router.push("contract-list");
    },
    save () {
      var cate = this.formInline.contractCatecory;
      this.formInline.editStatus = 0;
      var cond = this.formInline1.condition;
      this.formInline.payCondition = cond.join(",");
      this.formInline.contractType = 0;
      //如果不是租赁合同，合同订单类型字段置空
      if (cate != "CT-ZL") {
        this.formInline.nwSale = "";
      }
      this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
      this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
      this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
      if (this.formInline.paymentList) {
        this.formInline.paymentList.forEach((obj) => {
          obj.billDate = this.formatDate(obj.billDate);
        })
      }
      if (cate == "CT-ZL" && this.formInline.zltype == '3') {
        var totalMoney = new big(0);
        if (this.formInline.zlList) {
          this.formInline.zlList.forEach((obj) => {
            totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
          })
        }
        this.formInline.contractAmount = totalMoney;
      }
      this.formInline.zlList = this.formInline.zlList;
      ss.contractService.insert(this.formInline).then(rd => {
        if (rd.f) {
          this.$msg.msgs("保存成功！");
          this.$router.push("contract-list");
        } else {
          this.$msg.msgs("保存失败！" + rd.msg);
        }
      });
    },
    submit () {
      this.formInline.salesCity = ''
      var subflag1 = false;
      var subflag2 = false;
      var subflag3 = false;
      var subflag4 = false;
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          subflag1 = true;
        } else {
          this.$msg.msge("请完善合同信息后再提交！");
          return false;
        }
      });
      if (!subflag1) {
        return;
      }
      console.log("节点", 1)
      var cate = this.formInline.contractCatecory;
      //如果不是租赁合同，合同订单类型字段置空
      if (cate != "CT-ZL") {
        this.formInline.nwSale = "";
      }
      if (cate != "CT-ZL" && cate != "CT-BZ") {
        this.$refs['form2'].validate((valid) => {
          if (valid) {
            subflag2 = true;
          } else {
            this.$msg.msge("请完善合同信息后再提交！");
            return false;
          }
        });
        if (!subflag2) {
          return;
        }
      }
      console.log("节点", 2)
      if (cate == "CT-CG") {
        var count = 0;
        var shulFlag = false;
        var cgManager = false;
        for (var i = 0; i < this.formInline.paymentList.length; i++) {
          count = Number(count) + Number(this.formInline.paymentList[i].paymentRatio);
        }
        for (var j = 0; j < this.formInline.productList.length; j++) {
          var data = this.formInline.productList[j];
          if (data.shuilv == null || data.shuilv == '') {
            shulFlag = true;
          }
          if (data.cgjingli == null || data.cgjingli == '') {
            cgManager = true;
          }
        }
        if (count != 100) {
          this.$msg.msge("付款比例之和必须为100%！");
          return;
        }
        if (shulFlag) {
          this.$msg.msge("税率不能为空！");
          return;
        }
        if (cgManager) {
          this.$msg.msge("采购经理不能为空！");
          return;
        }
      }
      if (cate == "CT-CG" || cate == "CT-ZL") {
        if (this.formInline.zltype != '2' && this.formInline.zltype != '3') {
          this.$refs['form3'].validate((valid) => {
            if (valid) {
              subflag3 = true;
            } else {
              this.$msg.msge("请完善合同信息后再提交！");
              return false;
            }
          });
        }
        this.$refs['form5'].validate((valid) => {
          if (valid) {
            subflag4 = true;
          } else {
            this.$msg.msge("请完善合同信息后再提交！");
            return false;
          }
        });
        if (this.formInline.zltype == '1') {
          if (!subflag3 || !subflag4) {
            return;
          }
        } else if (this.formInline.zltype == '2' || this.formInline.zltype == '3') {
          if (!subflag4) {
            return;
          }
        } else {
          if (!subflag3 || !subflag4) {
            return;
          }
        }
        console.log("节点", 3)
        if (cate == "CT-ZL" && this.formInline.zltype == '1') {
          var total = new big(0);
          for (var i = 0; i < this.formInline.paymentList.length; i++) {
            var p = this.formInline.paymentList[i];
            total = total.plus(new big(p.paymentAmount));
          }
          if (total != this.formInline.contractAmount) {
            this.$msg.msge("付款金额不等于合同金额");
            return;
          }
          //产品
          var totalMoney = new big(0);

          for (var i = 0; i < this.formInline.zlList.length; i++) {
            var q = this.formInline.zlList[i];
            totalMoney = totalMoney.plus(new big(q.productUnitPrice).times(q.rentNum));

          }
          console.log(totalMoney + "adsd");
          if (totalMoney != this.formInline.contractAmount) {
            this.$msg.msge("产品总价不等于合同金额");
            return;
          }
        }

        if (cate == "CT-ZL" && this.formInline.zltype == '3') {
          var zulin = this.formInline.zlList[0];
          for (var i = 0; i < this.formInline.zlList.length; i++) {
            var zl = this.formInline.zlList[i];
            if (zl.productCode == '' || zl.productCode == null) {
              this.$msg.msge("产品型号不能为空！");
              return;
            }
            if (zl.productCode == '' || zl.productCode == null) {
              this.$msg.msge("产品型号不能为空！");
              return;
            }
            if (zl.priceType == '' || zl.priceType == null) {
              this.$msg.msge("费用名称不能为空！");
              return;
            }
            /*		if(i>0){
                  if(zulin.priceType == zl.priceType){
                    this.$msg.msge("费用名称不可重复,请修改后重新提交！");
                    return;
                  }
                }*/
          }
        }

      } else if (cate != "CT-BZ" && cate != "CT-DLS-KJ") {
        var cond = this.formInline1.condition;
        if (cond.indexOf("现金") != -1) {
          if (this.isEmpty(this.formInline.cashAmount) || this.isEmpty(this.formInline.cashRatio)) {
            this.$msg.msge("请填写现金信息");
            return;
          }
        } else {
          if (this.isNotEmpty(this.formInline.cashAmount) || this.isNotEmpty(this.formInline.cashRatio)) {
            this.$msg.msge("现金选项未勾选");
            return;
          }
        }
        if (cond.indexOf("信贷") != -1) {
          if (this.isEmpty(this.formInline.creditAmount) || this.isEmpty(this.formInline.creditRatio)) {
            this.$msg.msge("请填写信贷信息");
            return;
          }
        } else {
          if (this.isNotEmpty(this.formInline.creditAmount) || this.isNotEmpty(this.formInline.creditRatio)) {
            this.$msg.msge("信贷选项未勾选");
            return;
          }
        }
        var ratio1 = parseInt(this.isEmpty(this.formInline.cashRatio) ? 0 : this.formInline.cashRatio);
        var ratio2 = parseInt(this.isEmpty(this.formInline.creditRatio) ? 0 : this.formInline.creditRatio);
        if (ratio1 + ratio2 != 100) {
          this.$msg.msge("现金和信贷比例总和不为100%");
          return;
        }
        var amount1 = parseInt(this.isEmpty(this.formInline.cashAmount) ? 0 : this.formInline.cashAmount);
        var amount2 = parseInt(this.isEmpty(this.formInline.creditAmount) ? 0 : this.formInline.creditAmount);
        var amount = parseInt(this.formInline.contractAmount);
        if (amount1 + amount2 != amount) {
          this.$msg.msge("现金和信贷总和不等于合同金额");
          return;
        }
        this.formInline.payCondition = cond.join(",");
      }
      this.$msg.confirm("确定要提交吗？", () => {
        this.formInline.editStatus = 1;
        this.formInline.contractType = 0;
        this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
        this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
        this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
        if (this.formInline.paymentList) {
          this.formInline.paymentList.forEach((obj) => {
            obj.billDate = this.formatDate(obj.billDate);
          })
        }
        console.log(1211, this.formInline);
        if (cate == "CT-ZL" && this.formInline.zltype == '3') {
          var totalMoney = new big(0);
          if (this.formInline.zlList) {
            this.formInline.zlList.forEach((obj) => {
              totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
            })
          }
          this.formInline.contractAmount = totalMoney;
        }

        ss.contractService.insert(this.formInline).then(rd => {
          if (rd.f) {
            this.$msg.msgs("提交成功！");
            this.$router.push("contract-list");
          } else {
            this.$msg.msgs("提交失败！" + rd.msg);
          }
        })
      })
    },
    isEmpty (attr) {
      if (attr == null || attr == "") {
        return true;
      } else {
        return false;
      }
    },
    isNotEmpty (attr) {
      if (attr != null && attr != "") {
        return true;
      } else {
        return false;
      }
    },
    changeCatogory (attr) {
      this.guanlianxiangmFlag = false;
      this.formInline.salesCity = '';
      var usertype = 1;//经销商
      if (attr == "CT-CG" || attr == "采购合同") {
        usertype = 2;//供应商
        this.cgflag = true;
        this.zlflag = false;
        this.bzflag = false;
        this.dlsflag = false;
        this.hhxmflag = false;
        this.customerlabel = "供应商名称";

        //获取采购项目列表
        ss.contractService.selectCgProList().then(rd => {
          this.allProjectByUser = rd.msg;
        });
        this.getCompany();
        // this.formInline.paymentList[0].nodeName = "质保金";
        this.allProjectByUser = this.tempProject2;
      } else if (attr == "CT-ZL" || attr == "租赁合同") {
        this.cgflag = false;
        this.zlflag = true;
        this.bzflag = false;
        this.dlsflag = false;
        this.hhxmflag = false;
        this.customerlabel = "客户名称";
        this.formInline.paymentList[0].newflag = true;
        this.formInline.paymentList[0].nodeName = "";
        if (this.formInline.zltype == '3') {
          this.jzxFlag = true;
          this.formInline.zltype = 3
        } else if (this.formInline.zltype == '1' || this.formInline.zltype == '2') {
          this.jzxFlag = false;
        }
      } else if (attr == "CT-BZ" || attr == "标准合同") {
        this.bzflag = true;
        this.cgflag = false;
        this.zlflag = false;
        this.dlsflag = false;
        this.hhxmflag = false;
        this.customerlabel = "客户名称";
        this.allProjectByUser = this.tempProject;
      } else if (attr == "CT-HT" || attr == "项目合同") {
        this.bzflag = false;
        this.cgflag = false;
        this.zlflag = false;
        this.dlsflag = false;
        this.hhxmflag = true;
        this.customerlabel = "客户名称";
        this.allProjectByUser = this.tempProject;
      } else if (attr == "CT-DLS-KJ" || attr == "经销商框架合同") {
        //获取当前登录人的公司
        var data1 = {};
        data1.usercode = this._user.usercode;
        data1.type = 18;
        ss.resourcePool.getAuthByCode(data1).then(rd => {
          var list = rd.msg;
          for (var i = 0; i < list.length; i++) {
            var data = list[i];
            if (data.code == "0PN0" || data.code == "1R60" || data.code == "1JC0" || data.code == "1S00") {
              this.shichang = false;
            }
          }
          if(this.shichang){
            this.$router.push("/contract-agentnew")
          }else {
            this.bzflag = false;
            this.cgflag = false;
            this.zlflag = false;
            this.dlsflag = true;
            this.hhxmflag = false;
            this.tabIndex = '1';
            this.customerlabel = "客户名称";
            this.allProjectByUser = this.tempProject;
            var data = {};
            data.usercode = this._user.usercode;
            data.type = 18;
          }
        })
      } else {
        this.cgflag = false;
        this.zlflag = false;
        this.bzflag = false;
        this.dlsflag = false;
        this.customerlabel = "客户名称";
        this.allProjectByUser = this.tempProject;
      }
      this.changeGetCurrency()
      this.customerList = [];
      if (attr != "CT-CG" && attr != "采购合同" && attr != "CT-DLS-KJ" && attr != "经销商框架合同") {

        ss.contractService.getCustomerList({ usertype: usertype, status: 1 }).then(rd => {
          this.customerList = rd;
        });
      }
      if (attr == "CT-DLS-KJ" || attr == "经销商框架合同") {
        ss.contractService.getCustomerList({ usertype: usertype, delflag: 1 }).then(rd => {
          this.customerList = rd;
        });
      }
    },
    lianqunOptions (value) {
      console.log("value", value);
      console.log("this.formInline.contractAgent", this.formInline.contractAgent);

      //如果是国内市场,并且是专营商,用户个数大于5只能选一个链群

      if (this.formInline.contractAgent == null || this.formInline.contractAgent == '') {
        this.$msg.msge("请选选择经销商合同类型！");
        this.lianqunList = []
      }

      if (this.isCt1 && this.formInline.contractAgent == '3') {
        if (this.formInline.userNum != null && this.formInline.userNum != '') {
          if (this.formInline.userNum > 5 && value.length > 1) {
            this.$msg.msge("专营商用户个数大于5时,只可勾选一个链群！");
            this.lianqunList = []
          }
        } else {
          this.$msg.msge("请选填写用户个数！");
          this.lianqunList = []
        }
      }
      var jsonObj = value
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
      console.log(this.formInline.lianqun);
    },
    changeUserNum () {
      console.log(1111)
      if (this.isCt1 && this.formInline.contractAgent == '3') {
        this.lianqunList = []
      }
    },
    submitAgent (rd) {
      var subflag1 = false;
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          subflag1 = true;
        } else {
          this.$msg.msge("请完善合同信息后再提交！");
          return false;
        }
      });
      if (!subflag1) {
        return;
      }
      this.formInline.salesCity = this.citys;
      console.log("节点", 1)
      var cate = this.formInline.contractCatecory;
      this.formInline.isZc = rd;
      this.formInline.nwSale = "";
      this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
      this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
      ss.contractService.getDlsContract(this.formInline).then(rd => {
        console.log(rd);
        //存在合同
        if (rd.msg > 0) {
          this.$msg.confirm("当前经销商存在" + rd.msg + "条可用合同,如果重复请作废!确定要提交吗？", () => {
            this.formInline.status = 0;
            this.formInline.editStatus = 1;
            this.formInline.contractType = 0;
            console.log(1211, this.formInline);
            ss.contractService.insertAgent(this.formInline).then(rd => {
              if (rd.f) {
                this.$msg.msgs("提交成功！");
                this.$router.push("contract-list");
              } else {
                this.$msg.msgs("提交失败！" + rd.msg);
              }
            })
          })
        } else {
          this.$msg.confirm("确定要提交吗？", () => {
            this.formInline.status = 0;
            this.formInline.editStatus = 1;
            this.formInline.contractType = 0;
            this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
            this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
            console.log(1211, this.formInline);
            ss.contractService.insertAgent(this.formInline).then(rd => {
              if (rd.f) {
                this.$msg.msgs("提交成功！");
                this.$router.push("contract-list");
              } else {
                this.$msg.msgs("提交失败！" + rd.msg);
              }
            })
          })
        }
      })
    },
    submitHHxm (rd) {
      var subflag4 = false;
      this.$refs['form4'].validate((valid) => {
        if (valid) {
          subflag4 = true;
        } else {
          this.$msg.msge("请完善合同信息后再提交！");
          return false;
        }
      });
      //如果不是租赁合同，合同订单类型字段置空
      this.formInline.nwSale = "";
      if (!subflag4) {
        return;
      }
      this.formInline.salesCity = this.citys;
      this.formInline.isZc = rd;
      this.formInline.status = 0;
      ss.contractService.insertHhxm(this.formInline).then(rd => {
        if (rd.f) {
          if (1 == this.formInline.isZc) {
            this.$msg.msgs("暂存成功！");
          } else if (0 == this.formInline.isZc) {
            this.$msg.msgs("提交成功！");
          }
          this.$router.push("contract-list").then(() => {
            window.location.reload()
          });
        } else {
          this.$msg.msgs("提交失败！" + rd.msg);
        }
      })



    },
    formatDate (date) {
      if (this.isNotEmpty(date)) {
        function addDateZero (num) {
          return (num < 10 ? "0" + num : num);
        }
        let d = new Date(date);
        let format = d.getFullYear() + "-" + addDateZero(d.getMonth() + 1) + "-" + addDateZero(d.getDate());
        return format;
      }
    },
    //产品大类初始化
    selectProduct1 () {
      ss.ProService.product1HtSelect(this.formInline.zltype).then(rd => {
        this.optionsProduct1 = rd;
      })
    },
    //租赁业务重新获取产品大类初始化
    selectZlProduct1 () {
      this.changeGetCurrency()
      if (this.formInline.zltype == '3') {
        this.jzxFlag = true;
      } else if (this.formInline.zltype == '1' || this.formInline.zltype == '2') {
        this.jzxFlag = false;
      }

      this.formInline.zlList = [
        {
          productType: '',
          productCode: '',
          rentNum: 1,
          productName: '',
          productUnitPrice: '',
          pickerOptions2: []
        }
      ]
      ss.ProService.product1HtSelect(this.formInline.zltype).then(rd => {
        this.optionsProduct1 = rd;
      })
    },
    selectnwSale (val) {
      console.log(val)
    },
    //大类修改时，带出产品型号
    changeBig (row) {
      if (this.formInline.zltype == '2') {
        ss.ProService.product2NoOemSelectZl(row.productType).then(rd => {
          row.optionsProduct2 = rd;
        })
      } else {
        ss.ProService.product2NoOemSelect(row.productType).then(rd => {
          row.optionsProduct2 = rd;
        })
      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    // 关闭新手引导页
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextStep (i) {
      if (this.status == 1) {
        this.status = 2;
      } else if (this.status == 2) {
        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    // 时间戳转换日期
    timestampToTime (timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let D = date.getDate().toString().padStart(2, 0);
      let h = date.getHours() + ':';
      let m = date.getMinutes() + ':';
      let s = date.getSeconds();
      return Y + '-' + M + '-' + D;//+h+m+s
    },
    yearLastData () {
      const today = new Date();
      const year = today.getFullYear();
      const lastDayOfYear = new Date(year, 11, 31); // 直接设置年份、月份和日期
      return lastDayOfYear;
    },
    /**
     * 查询当天日期
     */
    // getNowDate(d) {
    //   const timeOne = new Date()
    //   const year = timeOne.getFullYear()
    //   let month = timeOne.getMonth() + 1
    //   let day = timeOne.getDate()
    //   month = month < 10 ? '0' + month : month
    //   day = day < 10 ? '0' + day : day
    //   const NOW_MONTHS_AGO = `${year}-${month}-${day}`
    //   return NOW_MONTHS_AGO
    // },
    stRentTime () {
      let that = this;
      that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
      that.formInline.contractEndtime = that.timestampToTime(new Date().getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000);// 默认结束日期
      for (var i = 0; i < this.rentTimeList.length; i++) {
        var priceData = this.rentTimeList[i];
        if (priceData.rentTerm == this.formInline.rentTime) {
          that.formInline.rentPrice = priceData.rentPrice;
          if (this.formInline.zlList) {
            for (var j = 0; j < this.formInline.zlList.length; j++) {
              var zl = this.formInline.zlList[j];
              if (zl.priceType == 'ZL01') {
                zl.productUnitPrice = priceData.rentPrice;
              }
            }
          }
        }
      }
    },
    setZlDate () {
      let that = this;
      var newDate = new Date(that.formInline.contractStarttime);
      if (this.formInline.contractCatecory == "CT-DLS-KJ" || this.formInline.contractCatecory == "经销商框架合同") {
        that.formInline.contractEndtime = that.yearLastData();// 默认结束日期

        console.log(that.formInline.contractEndtime);

        if (that.formInline.contractEndtime < that.timestampToTime(new Date().getTime())) {
          that.formInline.contractEndtime = that.timestampToTime(new Date().getTime());
        }

      } else if (this.formInline.contractCatecory != "CT-CG" && this.formInline.contractCatecory != "采购合同") {
        that.formInline.contractEndtime = that.timestampToTime(newDate.getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000);// 默认结束日期
      }
    },
    getRentTime () {
      var data = {
        rentType: null,
      }
      let that = this;
      if (that.formInline.rentType) {
        data.rentType = this.formInline.rentType;
        ss.contractService.selectRentTimeByType(data).then(rd => {
          if (rd.f) {
            that.rentTimeList = rd.msg;
            that.formInline.rentTime = that.rentTimeList[0].rentTerm;// 默认租赁天数
            that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
            that.formInline.contractEndtime = that.timestampToTime(new Date().getTime() + that.formInline.rentTime * 24 * 60 * 60 * 1000);
            that.formInline.rentPrice = that.rentTimeList[0].rentPrice;
          }
        })
      }
    },
    getRentPrice (priceType, index) {
      //租赁费的话,根据租赁类型和租赁天数获取租赁价格
      if (priceType == 'ZL01') {

        this.formInline.zlList[index].productUnitPrice = this.formInline.rentPrice;
      } else {
        //根据费用类型获取价格
        var data = {
          priceType: null,
          isShhm: 0,
          isJj: 0,
        }
        data.priceType = priceType;
        if (data.priceType == 'ZL05') {
          data.isJj = 1;
        } else if (data.priceType == 'ZL08') {
          data.isShhm = 1;
        }
        ss.contractService.selectByRentType(data).then(rd => {
          if (rd.f) {
            var list = rd.msg;
            this.formInline.zlList[index].productUnitPrice = list[0].untiPrice;
          }
        })
      }
    },

    showAgentList (value) {
      ss.UserService.selectAgentByName(value).then(rd => {
        console.log(rd);
        this.oneAgentList = rd.msg;
      })
    },
    changeAgent (value) {
      this.formInline.oneLevelAgentName = value.customerName
      this.formInline.oneLevelAgent = value.usercode
      //清空链群和销售区域
      this.lianqunList = '';
      this.formInline.lianqun = '';
      this.formInline.saleareaCode = '';
      this.salesRegion = [];
      //根据一级经销商编码查询对应链群和销售区域
      ss.UserService.getAgentByCodeOne(value.usercode).then(rd => {
        console.log("getAgentByCodeOne", rd.msg.lianqun);
        this.salesRegion = rd.msg.areaList;
        this.yiji = true;
        if (rd.msg.lianqun.length <= 0) {
          this.lianqunList = ''
        } else {
          this.lianqunList = rd.msg.lianqun
        }
        var jsonObj = rd.msg.lianqun
        var jStr = '';
        for (var item in jsonObj) {
          jStr += jsonObj[item] + ",";
        }
        console.log("getAgentByCodeOne", jStr);
        this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
      })
    },
    getCity (value) {
      this.citys = value.join(",")
    },
    changeArea (query) {
      console.log(query)
      var areas = [];
      this.formInline.salesCity = '';
      if (this.yiji) {
        const salesRegionItem = this.salesRegion.find(item => item.code === query);
        areas.push(salesRegionItem.refid)
      } else {
        areas.push(query.refid)
      }
      ss.UserService.getCityByArea(areas).then(rd => {
        console.log(rd);
        this.salesCity = rd.msg;
      })
    },
    //获取当前登录人公司
    getCompany () {
      ss.contractService.getUserCompany().then(rd => {
        if (rd.f) {
          if (rd.msg == '0PN0' || rd.msg == '1R60' || rd.msg == '1S00' || rd.msg == '44U0') {
            this.selectProFlag = true;
            //康盛跟海盛杰的人获取全部可用供应商
            ss.ProService.getAllSupplier("").then(rd => {
              console.log(rd, "optionsSupplier");
              if (rd.f) {
                for (var i = 0; i < rd.msg.length; i++) {
                  var data = rd.msg[i];
                  this.customerList.push({ "usercode": data.usercode, "username": data.userName });
                }
              }
            })
          }
        }
      })
    },
    showProcuct1 () {
      var product = {};
      product.productId = "";
      product.productName = "";
      product.oemDesc = "";
      product.unitPrice = 0;
      product.currency = "";
      product.shuilv = "";
      product.cgjingli = "";
      this.formInline.productList.push(product);
    },
    selectDetailModel (v) {
      ss.contractService.getOemProducts(v.productId).then(rd => {
        if (rd.f) {
          if (rd.msg != null) {
            v.productId = rd.msg.materialCode || ''
            v.productName = rd.msg.materialDescrition || ''
            v.oemDesc = rd.msg.oemDesc || ''
          } else {
            v.productName = rd.msg.materialDescrition || ''
            v.oemDesc = rd.msg.oemDesc || ''
            this.$msg.msge("产品型号编码不存在，请重新输入");
          }
        }
      });
    },
    keyupEvent (e, input) {
      e.target.value = e.target.value.replace(/[^\d.]/g, '');
      e.target.value = e.target.value.replace(/\.{2,}/g, '.');
      e.target.value = e.target.value.replace(/^\./g, '0.');
      e.target.value = e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0, e.target.value.length - 1));
      e.target.value = e.target.value.replace(/^0[^\.]+/g, '0')
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
      this.input = e.target.value
    },
    //删除子件信息
    delzhongbiao (v, row) {
      this.formInline.productList.splice(v, 1);
    },
    changeContractAgent(value){
      var code = value.code;
      if(code == '11' || code == '12' || code == '13'){
        this.isKa = true;
      }else {
        this.isKa = false;
      }
      this.formInline.caigouquyu = '';
    },

    changeDlsType (value) {
      this.lianqunList = []
      this.formInline.salechannelCode = '';
      this.formInline.contractStarttime = '';
      this.formInline.contractEndtime = '';
      if (value == '国内市场经销合同') {
        this.isCt1 = true;
        this.isNA9 = false;
        this.isKs1 = false;
        this.isSj1 = false;
        this.isHh1 = false;
        this.isXueYe = false;
      } else if (value == '康盛合同') {
        this.isCt1 = false;
        this.isNA9 = false;
        this.isKs1 = true;
        this.isSj1 = false;
        this.isHh1 = false;
        this.isXueYe = false;
      } else if (value == '鸿鹄合同') {
        this.isCt1 = false;
        this.isNA9 = true;
        this.isKs1 = false;
        this.isSj1 = false;
        this.isHh1 = false;
        this.isXueYe = false;
      } else if (value == '海盛杰合同') {
        this.isCt1 = false;
        this.isNA9 = false;
        this.isKs1 = false;
        this.isSj1 = true;
        this.isHh1 = false;
        this.isXueYe = false;
      } else if (value == '厚宏合同') {
        this.isCt1 = false;
        this.isNA9 = false;
        this.isKs1 = false;
        this.isSj1 = false;
        this.isHh1 = true;
        this.isXueYe = false;
      } else if (value == '国内市场经销合同-血液') {
        this.isCt1 = false;
        this.isNA9 = false;
        this.isKs1 = false;
        this.isSj1 = false;
        this.isHh1 = false;
        this.isXueYe = true;
      }
    },
    //框架合同table页
    tabchange (i) {
      console.log(i);
      this.tabIndex = i;
      if (this.tabIndex == '1') {
        this.tabflag = true;
      } else if (this.tabIndex == '3') {
        this.tabflag = true;
      } else if (this.tabIndex == '2') {
        this.tabflag = true;
      }
    },
  },
  mounted () {
    // 产品型号 - 集装箱
    let that = this;
    ss.contractService.selectByCode({ prodcode: '' }).then(rd => {
      if (rd.f) {
        that.optionsProduct2_jzx = rd.msg.map((item, index) => {
          return Object.assign({}, { 'id': item.prodcode, 'levelname': item.promodel })
        });
      }
    })
    //获取当前用户所有项目详情
    ss.OrderService.projectManagePageG().then(rd => {
      this.allProjectByUser = rd;
      this.tempProject = rd;
      this.tempProject2 = _.filter(rd, (pro) => {
        return pro.type == 5;
      })
    });
    if (this.contractId != null) {
      ss.contractService.detail(this.contractId).then(rd => {
        this.guanlianxiangmFlag = false;

        this.formInline = rd.obj;
        // console.log(this.formInline.fukuanobj+"婕宝贝");
        if (this.isNotEmpty(rd.obj.contractCatecory)) {
          this.changeCatogory(rd.obj.contractCatecory);
        }

        //租赁特殊处理
        if (rd.obj.contractCatecory == "CT-ZL") {
          rd.obj['fukuanobj'] = [];
          this.formInline = rd.obj;
          this.formInline.fukuanobj.push({
            nodeName: "押金", paymentRatio: rd.obj.contractCashRadio, paymentDays: rd.obj.contractCashDays,
            newflag: false, netValue: rd.obj.contractCashNetValue, paymentAmount: rd.obj.contractCashPledge
          });
        }


        this.formInline1.wuliufangshi = this.formInline.wuliufangshi;
        this.formInline.paymentList = this.isEmpty(this.formInline.paymentList) ? [{
          nodeName: "", newflag: false, paymentRatio: "", posnr: "",
          paymentAmount: "", netValue: "", paymentDays: "", isNeedcred: "", billDate: ""
        }] : this.formInline.paymentList;
        if (this.formInline.payCondition != null) {
          if (this.formInline.payCondition.indexOf("现金") != -1) {
            this.formInline1.condition.push("现金");
          }
          if (this.formInline.payCondition.indexOf("信贷") != -1) {
            this.formInline1.condition.push("信贷");
          }
        }
        if (this.formInline.paymentList != null) {
          var flag = 0;
          for (var i = 0; i < this.formInline.paymentList.length; i++) {
            var p = this.formInline.paymentList[i];
            if (p.nodeName == "质保金" && flag == 0) {
              p.newflag = false;
              flag = 1;
            } else {
              p.newflag = true
            }
          }
        }
      })
    } else {
      // this.formInline.id=util.getUuid();
      // this.contractId = this.formInline.id;
      var coflag = {
        codeflag: 6
      }
      ss.contractService.getContractCode(coflag).then(rd => {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
          month = 0 + month.toString();
        }
        this.formInline.id = year.toString() + month.toString() + day.toString() + "HT" + rd;
        this.contractId = this.formInline.id;
        console.log(year.toString() + month.toString() + day.toString());
        console.log(this.formInline.id);
      })
    };
    this.selectProduct1();

  },
  created () {

    this.showzhezhao();
  }
}
</script>

<style lang="scss">
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '天';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail1 .h-formbLine .el-form-item__label {
  width: 11%;
  text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__label {
  width: 34%;
  text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__content {
  width: 66%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10.4%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 89.6%;
}
.ljjtips .el-table tbody td .cell {
  padding: 0.2rem 0.1rem;
}
.outerCon {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 30px;

  .tabBtn {
    background-color: #f0f5fb;
    padding: 10px;
    border: 1px solid #dae0f0;
    margin-right: 10px;
    color: #282c2f;
    cursor: pointer;
  }

  .tabBtnAc {
    color: white;
    background-color: #2785e7;
  }
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}
.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}
.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;
  .leaderbg {
    width: 100%;
    height: 100%;
  }
  .steps {
    position: absolute;
    z-index: 1;
  }
  .step1 {
    top: 2.6rem;
    left: 3.15rem;
    width: 4rem;
    height: 1.7rem;
  }
  .step2 {
    top: 4.55rem;
    left: 3.9rem;
    width: 13.5rem;
    height: 2.3rem;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }
  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
